'use client';

import classnames from 'classnames';
import { useState } from 'react';
import Modal from 'react-modal';

import Icon from 'molecules/Icon';
import styles from 'molecules/Lightbox/lightbox.module.scss';

import type { FC, ReactNode } from 'react';

Modal.setAppElement('body');

interface LightboxProps {
  children: ReactNode;
  modalContent: ReactNode;
  classes?: Record<string, string>;
}

const Lightbox: FC<LightboxProps> = ({ children, modalContent, classes = {} }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <button onClick={() => setShowModal(true)} className={classnames(styles.trigger, classes.link)}>
        {children}
      </button>
      {/* TODO: Replace with Radix-Ui Dialog */}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Modal
        isOpen={showModal}
        contentLabel="onRequestClose Example"
        onRequestClose={() => setShowModal(false)}
        className={styles.content}
        overlayClassName={classnames(styles.overlay, {
          [classes.overlay]: classes.overlay,
        })}
      >
        <div>
          {modalContent}
          <button onClick={() => setShowModal(false)} className={classnames(styles.closeButton, classes.closeButton)}>
            <Icon icon="icon-cross" size={28} />
            <span className={styles.visuallyHidden}>Close Modal</span>
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Lightbox;
